import React, { useState, useRef, useEffect } from 'react';
import { useGlobalContext } from '../context/GlobalContext';
import { useTranslation } from 'react-i18next';

function LanguageDropdown({ languages, onSelect, showFlag = false }) {
  const { currentLang } = useGlobalContext();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { i18n, t } = useTranslation();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  if (!languages || Object.keys(languages).length <= 1) {
    return null;
  }

  const availableLanguages = Object.values(languages);

  const handleLanguageSelect = (languageCode, event) => {
    event.preventDefault();
    onSelect(languageCode);
    i18n.changeLanguage(languageCode);
    setIsOpen(false);
  };

  const handleToggle = (event) => {
    event.preventDefault();
    setIsOpen(!isOpen);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleToggle(e);
    }
  };

  const handleItemKeyDown = (e, languageCode) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleLanguageSelect(languageCode, e);
    }
    else if (e.key === 'ArrowDown') {
      e.preventDefault();
      const nextElement = e.target.closest('li').nextElementSibling?.querySelector('a');
      if (nextElement) nextElement.focus();
    }
    else if (e.key === 'ArrowUp') {
      e.preventDefault();
      const prevElement = e.target.closest('li').previousElementSibling?.querySelector('a');
      if (prevElement) prevElement.focus();
    }
    else if (e.key === 'Escape') {
      e.preventDefault();
      setIsOpen(false);
      dropdownRef.current?.querySelector('a[role="button"]')?.focus();
    }
  };

  return (
    <div className="btn-group" ref={dropdownRef} style={{ position: 'relative' }}>
      <a
        href="#"
        onClick={handleToggle}
        onKeyDown={handleKeyDown}
        className="mainColor"
        role="button" 
        aria-label="Sélectionner la langue" 
        aria-haspopup="true"
        aria-expanded={isOpen}
        tabIndex="0"
        style={{ 
          padding: '6px 12px',
          textDecoration: 'none',
          cursor: 'pointer'
        }}
      >
        <i className="fas fa-globe" aria-hidden="true"></i>
        {' '}
        <span 
          className="caret" 
          aria-hidden="true"
          style={{
            display: 'inline-block',
            width: 0,
            height: 0,
            marginLeft: '2px',
            verticalAlign: 'middle',
            borderTop: '4px solid',
            borderRight: '4px solid transparent',
            borderLeft: '4px solid transparent'
          }}
        />
      </a>
      
      {isOpen && (
        <ul 
          className="dropdown-menu dropdown-menu-right" 
          role="menu"
          aria-label="Options de langue"
          style={{
            position: 'absolute',
            top: '100%',
            right: 0,
            zIndex: 1000,
            display: 'block',
            minWidth: '160px',
            padding: '5px 0',
            margin: '2px 0 0',
            fontSize: '14px',
            backgroundColor: '#fff',
            border: '1px solid #ccc',
            borderRadius: '4px',
            boxShadow: '0 6px 12px rgba(0, 0, 0, 0.175)',
            listStyle: 'none'
          }}
        >
          {availableLanguages.map((language) => (
            <li key={language.code} style={{ listStyle: 'none' }} role="none">
              <a
                href="#"
                onClick={(e) => handleLanguageSelect(language.code, e)}
                onKeyDown={(e) => handleItemKeyDown(e, language.code)}
                className="text-capitalize mainColor"
                role="menuitem" 
                aria-label={`Changer la langue vers ${language.name}`} 
                tabIndex="0"
                style={{
                  display: 'block',
                  padding: '3px 20px',
                  clear: 'both',
                  fontWeight: 'normal',
                  lineHeight: '1.42857143',
                  color: '#333',
                  whiteSpace: 'nowrap',
                  textDecoration: 'none',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#f5f5f5';
                 
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                }}
              >
                {showFlag && (
                  <img
                    src={`/assets/images/flags/${language.code}.png`}
                    alt=""
                    className="img-thumbnail"
                    style={{ 
                      marginRight: '8px', 
                      width: '20px', 
                      height: 'auto',
                      padding: '2px',
                      border: '1px solid #ddd',
                      borderRadius: '2px'
                    }}
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                )}
                {language.name}
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default LanguageDropdown;